export * from './get-address-by-zipcode';
export * from './get-catalog';
export * from './get-orders';
export * from './get-order-detail';
export * from './get-payment-titles';
export * from './get-payment-detail';
export * from './get-starlink-content';
export * from './get-catalog-optout';
export * from './get-reseller-detail';
export * from './get-reseller-credit';
export * from './get-reseller-registration';
export * from './get-reseller-supervisor';
export * from './get-reseller-place';
export * from './incentive-campaign';
export * from './update-catalog-optout';
export * from './update-change-cadastral';
export * from './post-user-login';
